import { gql } from "@apollo/client";
import { ButtonBase, darken } from "@mui/material";
import { COLOR_BLACK, COLOR_BLACK_LIGHTER, COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import useData from "helpers/useData";
import getCompetitionStyle from "pages/potw/getCompetitionStyle";
import React from "react";

export default function VideoPotwCompetitionButton({ gameId }) {
  const [data] = useData(
    gql`
      query VideoPotwCompetitionButton($gameId: ID!) {
        game(id: $gameId) {
          id
          livePotwCompetition {
            id
            name
            competitionType
            startDate
            endDate
          }
        }
      }
    `,
    { gameId },
  );
  const livePotwCompetition = data?.game.livePotwCompetition;

  if (!livePotwCompetition) return null;
  const competitionStyle = getCompetitionStyle(livePotwCompetition.competitionType);
  const colorDarken = darken(COLOR_BLACK, 0.5);
  return (
    <ButtonBase
      href={`/potw/competitions/${livePotwCompetition.id}`}
      style={{
        background: `linear-gradient(130deg, ${COLOR_BLACK_LIGHTER}, ${colorDarken})`,
        color: COLOR_WHITE,
        fontFamily: FONT_FAMILY_GRAPHIK,
        fontWeight: 500,
        fontSize: 14,
        display: "flex",
        flexFlow: "row nowrap",
        padding: 5,
        gap: 10,
        justifyContent: "flex-start",
        textAlign: "left",
      }}
    >
      <div style={{ padding: 5 }}>
        <div
          style={{
            textTransform: "uppercase",
            textAlign: "left",
            marginBottom: 5,
            color: "#FF6B58",
          }}
        >
          {competitionStyle.title}
        </div>
        <div style={{ fontSize: 10, opacity: 0.8 }}>Rate the best highlights of the game!</div>
      </div>
    </ButtonBase>
  );
}
